import React from 'react'; 
import './comp.css';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import mailgo from "mailgo";
const { SubMenu } = Menu;

mailgo();


function Nav() {

      return (
        <div className="wrapper ">
            <a href="/"><h1 className="name">Franklin Cardona</h1></a>
            <Menu className = "menu" mode="horizontal">
                <Menu.Item><Link to='/about'>About</Link></Menu.Item>
                <Menu.Item><Link to='/experience'>Experience</Link></Menu.Item>
                <Menu.Item><Link to='/portfolio'>Portfolio</Link></Menu.Item>
                <SubMenu key="SubMenu" title="Links">
                    <Menu.Item><a href="https://github.com/franklincar" target="_blank" rel="noopener noreferrer">GitHub</a></Menu.Item>
                    <Menu.Item><a href="https://www.linkedin.com/in/cardonafranklin/" target="_blank" rel="noopener noreferrer">LinkedIn</a></Menu.Item>
                    <Menu.Item><a href="https://drive.google.com/file/d/1cN3uJfQNh2TCAluQSFOAWqXEtkr49boR/view?usp=sharing" target="_blank" rel="noopener noreferrer">Resume</a></Menu.Item>
                </SubMenu>
            <Menu.Item ><a href="mailto:franklin.a.cardona@gmail.com" target="_blank" rel="noopener noreferrer">Contact</a></Menu.Item>
            </Menu>
        </div>

      );
    
  }

export default Nav; 